import { render, staticRenderFns } from "./SearchTextInput.vue?vue&type=template&id=11aa810d&scoped=true&"
import script from "./SearchTextInput.vue?vue&type=script&lang=js&"
export * from "./SearchTextInput.vue?vue&type=script&lang=js&"
import style0 from "./SearchTextInput.vue?vue&type=style&index=0&id=11aa810d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11aa810d",
  null
  
)

export default component.exports